import fuzzysort from "fuzzysort";

import { SpaceliftVcsRepoCommitFile } from "shared/SpaceliftVcsRepo/useGetSpaceliftVcsRepoCommit/gql";

const SCORE_THRESHOLD = -10000;

const filterCommitFiles = (
  files: SpaceliftVcsRepoCommitFile[],
  query: string
): SpaceliftVcsRepoCommitFile[] => {
  if (!query) {
    return files;
  }

  const results = fuzzysort.go(query, files, {
    key: "filePath",
    threshold: SCORE_THRESHOLD,
  });

  return results.map((result) => result.obj);
};

export default filterCommitFiles;
